"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ad_hok_1 = require("ad-hok");
var addPropTrackingRef_1 = __importDefault(require("./addPropTrackingRef"));
var cleanupProps_1 = __importDefault(require("./cleanupProps"));
var addEffectOnUnmount = function (callback) {
    var _a;
    var handlerName = '_addEffectOnUnmount-handler';
    var handlerRefName = '_addEffectOnUnmount-handlerRef';
    return ad_hok_1.flowMax(ad_hok_1.addHandlers((_a = {},
        _a[handlerName] = function (props) { return function () {
            callback(props)();
        }; },
        _a)), addPropTrackingRef_1.default(handlerName, handlerRefName), ad_hok_1.addEffect(function (_a) {
        var _b = handlerRefName, handlerRef = _a[_b];
        return function () {
            return function () {
                handlerRef.current();
            };
        };
    }, []), cleanupProps_1.default([handlerName, handlerRefName]));
};
exports.default = addEffectOnUnmount;
